export const SET_HRMS15E_INDEX_DISP = 'SET_HRMS15E_INDEX_DISP'
export const GET_HRMS15E_INDEX_DISP = 'GET_HRMS15E_INDEX_DISP'
export const SET_HRMS15E_DETAIL_DISP = 'SET_HRMS15E_DETAIL_DISP'
export const GET_HRMS15E_DETAIL_DISP = 'GET_HRMS15E_DETAIL_DISP'
export const SET_HRMS15E_COLUMNS = 'SET_HRMS15E_COLUMNS'
export const GET_HRMS15E_COLUMNS = 'GET_HRMS15E_COLUMNS'
export const SET_HRMS15E_LABELS = 'SET_HRMS15E_LABELS'
export const GET_HRMS15E_LABELS = 'GET_HRMS15E_LABELS'
export const RECEIVED_HRMS15E_DROPDOWNS_COLUMNS_LABELS = 'RECEIVED_HRMS15E_DROPDOWNS_COLUMNS_LABELS'
export const GET_HRMS15E_MAX_ROWSPAN = 'GET_HRMS15E_MAX_ROWSPAN'
export const SET_HRMS15E_INDEX = 'SET_HRMS15E_INDEX'
export const GET_HRMS15E_INDEX = 'GET_HRMS15E_INDEX'
export const SET_HRMS15E_INDEX_SELECTED = 'SET_HRMS15E_INDEX_SELECTED'
export const GET_HRMS15E_INDEX_SELECTED = 'GET_HRMS15E_INDEX_SELECTED'
export const RECEIVED_HRMS15E_INDEX = 'RECEIVED_HRMS15E_INDEX'

export const SET_HRMS15E_DROPDOWNS = 'SET_HRMS15E_DROPDOWNS'
export const GET_HRMS15E_DROPDOWNS = 'GET_HRMS15E_DROPDOWNS'

export const SET_HRMS15E_DETAIL = 'SET_HRMS15E_DETAIL'
export const GET_HRMS15E_DETAIL = 'GET_HRMS15E_DETAIL'
export const SET_HRMS15E_DETAIL_DISABLED = 'SET_HRMS15E_DETAIL_DISABLED'
export const GET_HRMS15E_DETAIL_DISABLED = 'GET_HRMS15E_DETAIL_DISABLED'
export const SET_HRMS15E_DETAIL_DISABLED2 = 'SET_HRMS15E_DETAIL_DISABLED2'
export const GET_HRMS15E_DETAIL_DISABLED2 = 'GET_HRMS15E_DETAIL_DISABLED2'
export const SET_HRMS15E_DETAIL3_DESC3_DISABLED = 'SET_HRMS15E_DETAIL3_DESC3_DISABLED'
export const GET_HRMS15E_DETAIL3_DESC3_DISABLED = 'GET_HRMS15E_DETAIL3_DESC3_DISABLED'
export const SET_HRMS15E_DETAIL3_DISP = 'SET_HRMS15E_DETAIL3_DISP'
export const GET_HRMS15E_DETAIL3_DISP = 'GET_HRMS15E_DETAIL3_DISP'
export const SET_HRMS15E_DETAIL3_DESC3_DISP = 'SET_HRMS15E_DETAIL3_DESC3_DISP'
export const GET_HRMS15E_DETAIL3_DESC3_DISP = 'GET_HRMS15E_DETAIL3_DESC3_DISP'
export const SET_HRMS15E_DETAIL3_INFO_DISP = 'SET_HRMS15E_DETAIL3_INFO_DISP'
export const GET_HRMS15E_DETAIL3_INFO_DISP = 'GET_HRMS15E_DETAIL3_INFO_DISP'
export const RECEIVED_HRMS15E_DETAIL = 'RECEIVED_HRMS15E_DETAIL'

export const SET_HRMS15E_DETAIL1_DESC1_ADD_INLINE = 'SET_HRMS15E_DETAIL1_DESC1_ADD_INLINE'

export const RECEIVED_HRMS15E_DETAIL2_DESC1 = 'RECEIVED_HRMS15E_DETAIL2_DESC1'
export const RECEIVED_HRMS15E_DETAIL2_DESC2 = 'RECEIVED_HRMS15E_DETAIL2_DESC2'
export const SET_HRMS15E_DETAIL2_DESC1_ADD_INLINE = 'SET_HRMS15E_DETAIL2_DESC1_ADD_INLINE'

export const RECEIVED_HRMS15E_DETAIL3_DESC1 = 'RECEIVED_HRMS15E_DETAIL3_DESC1'
export const RECEIVED_HRMS15E_DETAIL3_DESC2 = 'RECEIVED_HRMS15E_DETAIL3_DESC2'
export const RECEIVED_HRMS15E_DETAIL3_DESC3 = 'RECEIVED_HRMS15E_DETAIL3_DESC3'
export const RECEIVED_HRMS15E_DETAIL3_INFO = 'RECEIVED_HRMS15E_DETAIL3_INFO'
export const SET_HRMS15E_DETAIL3_INFO_INLINE = 'SET_HRMS15E_DETAIL3_INFO_INLINE'
export const GET_HRMS15E_DETAIL3_INFO_INLINE = 'GET_HRMS15E_DETAIL3_INFO_INLINE'
export const POST_HRMS15E_DETAIL3_INFO_SAVE = 'POST_HRMS15E_DETAIL3_INFO_SAVE'
export const SET_HRMS15E_DETAIL3_INFO_DESC1_ADD_INLINE = 'SET_HRMS15E_DETAIL3_INFO_DESC1_ADD_INLINE'

export const SET_HRMS15E_DETAIL3_INFO_DESC2_POPUP = 'SET_HRMS15E_DETAIL3_INFO_DESC2_POPUP'
export const GET_HRMS15E_DETAIL3_INFO_DESC2_POPUP = 'GET_HRMS15E_DETAIL3_INFO_DESC2_POPUP'
export const RECEIVED_HRMS15E_DETAIL3_INFO_DESC2_POPUP = 'RECEIVED_HRMS15E_DETAIL3_INFO_DESC2_POPUP'

export const SET_HRMS15E_DETAIL3_INFO_DESC1_DISP = 'SET_HRMS15E_DETAIL3_INFO_DESC1_DISP'
export const GET_HRMS15E_DETAIL3_INFO_DESC1_DISP = 'GET_HRMS15E_DETAIL3_INFO_DESC1_DISP'

export const TOGGLE_HRMS15E_PAGE = 'TOGGLE_HRMS15E_PAGE'
export const POST_HRMS15E_DELETE = 'POST_HRMS15E_DELETE'

export const SET_HRMS15E_COURSE_GAP_POPUP = 'SET_HRMS15E_COURSE_GAP_POPUP'
export const GET_HRMS15E_COURSE_GAP_POPUP = 'GET_HRMS15E_COURSE_GAP_POPUP'
export const RECEIVED_HRMS15E_COURSE_GAP_POPUP = 'RECEIVED_HRMS15E_COURSE_GAP_POPUP'

export const SET_HRMS15E_DETAIL_COURSE = 'SET_HRMS15E_DETAIL_COURSE'
export const GET_HRMS15E_DETAIL_COURSE = 'GET_HRMS15E_DETAIL_COURSE'
export const RECEIVED_HRMS15E_DETAIL_COURSE = 'RECEIVED_HRMS15E_DETAIL_COURSE'
export const SET_HRMS15E_DETAIL_COURSE_ADD_INLINE_FROM_GAP = 'SET_HRMS15E_DETAIL_COURSE_ADD_INLINE_FROM_GAP'
export const SET_HRMS15E_DETAIL_COURSE_ADD_INLINE = 'SET_HRMS15E_DETAIL_COURSE_ADD_INLINE'
export const RECEIVED_HRMS15E_DETAIL_COURSE_ADD_INLINE = 'RECEIVED_HRMS15E_DETAIL_COURSE_ADD_INLINE'

export const RECEIVED_HRMS15E_DETAIL1_DESC2 = 'RECEIVED_HRMS15E_DETAIL1_DESC2'
export const POST_HRMS15E_DETAIL3_DESC1_SAVE = 'POST_HRMS15E_DETAIL3_DESC1_SAVE'

export const POST_HRMS15E_DETAIL1_SAVE = 'POST_HRMS15E_DETAIL1_SAVE'
export const POST_HRMS15E_DETAIL2_SAVE = 'POST_HRMS15E_DETAIL2_SAVE'
export const POST_HRMS15E_STATUS_SAVE = 'POST_HRMS15E_STATUS_SAVE'
export const POST_HRMS15E_SENDMAIL = 'POST_HRMS15E_SENDMAIL'
export const POST_HRMS15E_DETAIL_COURSE_SAVE = 'POST_HRMS15E_DETAIL_COURSE_SAVE'

export const GET_HRMS15E_DETAIL3_DESC3_INDEX_SELECTED = 'GET_HRMS15E_DETAIL3_DESC3_INDEX_SELECTED'
export const SET_HRMS15E_DETAIL3_DESC3_INDEX_SELECTED = 'SET_HRMS15E_DETAIL3_DESC3_INDEX_SELECTED'
export const GET_HRMS15E_DETAIL3_DESC3_SELECTED = 'GET_HRMS15E_DETAIL3_DESC3_SELECTED'
export const SET_HRMS15E_DETAIL3_DESC3_SELECTED = 'SET_HRMS15E_DETAIL3_DESC3_SELECTED'
export const GET_HRMS15E_DETAIL3_INFO = 'GET_HRMS15E_DETAIL3_INFO'
export const SET_HRMS15E_DETAIL3_INFO = 'SET_HRMS15E_DETAIL3_INFO'
export const GET_HRMS15E_DETAIL3_INFO_SELECTED = 'GET_HRMS15E_DETAIL3_INFO_SELECTED'
export const SET_HRMS15E_DETAIL3_INFO_SELECTED = 'SET_HRMS15E_DETAIL3_INFO_SELECTED'

export const GET_HRMS15E_DETAIL1_DESC2 = 'GET_HRMS15E_DETAIL1_DESC2'
export const SET_HRMS15E_DETAIL1_DESC2 = 'SET_HRMS15E_DETAIL1_DESC2'
export const GET_HRMS15E_DETAIL1_DESC2_SELECTED = 'GET_HRMS15E_DETAIL1_DESC2_SELECTED'
export const SET_HRMS15E_DETAIL1_DESC2_SELECTED = 'SET_HRMS15E_DETAIL1_DESC2_SELECTED'
export const GET_HRMS15E_SHOW_DETAIL_DESC_DISP = 'GET_HRMS15E_SHOW_DETAIL_DESC_DISP'
export const SET_HRMS15E_SHOW_DETAIL_DESC_DISP = 'SET_HRMS15E_SHOW_DETAIL_DESC_DISP'
export const GET_HRMS15E_DETAIL1_DISP = 'GET_HRMS15E_DETAIL1_DISP'
export const SET_HRMS15E_DETAIL1_DISP = 'SET_HRMS15E_DETAIL1_DISP'
export const GET_HRMS15E_DETAIL1_DESC1_DISP = 'GET_HRMS15E_DETAIL1_DESC1_DISP'
export const SET_HRMS15E_DETAIL1_DESC1_DISP = 'SET_HRMS15E_DETAIL1_DESC1_DISP'

export const GET_HRMS15E_DETAIL2_DESC2 = 'GET_HRMS15E_DETAIL2_DESC2'
export const SET_HRMS15E_DETAIL2_DESC2 = 'SET_HRMS15E_DETAIL2_DESC2'
export const GET_HRMS15E_DETAIL2_DESC2_SELECTED = 'GET_HRMS15E_DETAIL2_DESC2_SELECTED'
export const SET_HRMS15E_DETAIL2_DESC2_SELECTED = 'SET_HRMS15E_DETAIL2_DESC2_SELECTED'

export const GET_HRMS15E_DETAIL_DISABLED1 = 'GET_HRMS15E_DETAIL_DISABLED1'
export const SET_HRMS15E_DETAIL_DISABLED1 = 'SET_HRMS15E_DETAIL_DISABLED1'
export const GET_HRMS15E_DETAIL_DISABLED3 = 'GET_HRMS15E_DETAIL_DISABLED3'
export const SET_HRMS15E_DETAIL_DISABLED3 = 'SET_HRMS15E_DETAIL_DISABLED3'

export const GET_HRMS15E_DETAIL3_DESC1 = 'GET_HRMS15E_DETAIL3_DESC1'
export const SET_HRMS15E_DETAIL3_DESC1 = 'SET_HRMS15E_DETAIL3_DESC1'
export const GET_HRMS15E_DETAIL3_DESC1_SELECTED = 'GET_HRMS15E_DETAIL3_DESC1_SELECTED'
export const SET_HRMS15E_DETAIL3_DESC1_SELECTED = 'SET_HRMS15E_DETAIL3_DESC1_SELECTED'

export const GET_HRMS15E_DETAIL3_DESC2 = 'GET_HRMS15E_DETAIL3_DESC2'
export const SET_HRMS15E_DETAIL3_DESC2 = 'SET_HRMS15E_DETAIL3_DESC2'
export const GET_HRMS15E_DETAIL3_DESC3 = 'GET_HRMS15E_DETAIL3_DESC3'
export const SET_HRMS15E_DETAIL3_DESC3 = 'SET_HRMS15E_DETAIL3_DESC3'
export const GET_HRMS15E_DETAIL3_DESC1_DISP = 'GET_HRMS15E_DETAIL3_DESC1_DISP'
export const SET_HRMS15E_DETAIL3_DESC1_DISP = 'SET_HRMS15E_DETAIL3_DESC1_DISP'
export const GET_HRMS15E_DETAIL3_DESC2_DISP = 'GET_HRMS15E_DETAIL3_DESC2_DISP'
export const SET_HRMS15E_DETAIL3_DESC2_DISP = 'SET_HRMS15E_DETAIL3_DESC2_DISP'
export const GET_HRMS15E_DETAIL3_INFO_LEFT_DISP = 'GET_HRMS15E_DETAIL3_INFO_LEFT_DISP'
export const SET_HRMS15E_DETAIL3_INFO_LEFT_DISP = 'SET_HRMS15E_DETAIL3_INFO_LEFT_DISP'
export const GET_HRMS15E_DETAIL3_INFO_DESC1_COURSE_DISP = 'GET_HRMS15E_DETAIL3_INFO_DESC1_COURSE_DISP'
export const SET_HRMS15E_DETAIL3_INFO_DESC1_COURSE_DISP = 'SET_HRMS15E_DETAIL3_INFO_DESC1_COURSE_DISP'
export const GET_HRMS15E_DETAIL3_SELECTED = 'GET_HRMS15E_DETAIL3_SELECTED'
export const SET_HRMS15E_DETAIL3_SELECTED = 'SET_HRMS15E_DETAIL3_SELECTED'
export const GET_HRMS15E_FLG_DISABLED = 'GET_HRMS15E_FLG_DISABLED'
export const SET_HRMS15E_FLG_DISABLED = 'SET_HRMS15E_FLG_DISABLED'
export const GET_HRMS15E_DETAIL3_INFO_INDEX_SELECTED = 'GET_HRMS15E_DETAIL3_INFO_INDEX_SELECTED'
export const SET_HRMS15E_DETAIL3_INFO_INDEX_SELECTED = 'SET_HRMS15E_DETAIL3_INFO_INDEX_SELECTED'
export const GET_HRMS15E_SUMSCORE = 'GET_HRMS15E_SUMSCORE'
export const SET_HRMS15E_SUMSCORE = 'SET_HRMS15E_SUMSCORE'
export const RECEIVED_HRMS15E_SUMSCORE = 'RECEIVED_HRMS15E_SUMSCORE'
export const GET_HRMS15E_DETAIL1_DESC2_INDEX_SELECTED = 'GET_HRMS15E_DETAIL1_DESC2_INDEX_SELECTED'
export const SET_HRMS15E_DETAIL1_DESC2_INDEX_SELECTED = 'SET_HRMS15E_DETAIL1_DESC2_INDEX_SELECTED'
export const GET_HRMS15E_DETAIL2_DESC2_INDEX_SELECTED = 'GET_HRMS15E_DETAIL2_DESC2_INDEX_SELECTED'
export const SET_HRMS15E_DETAIL2_DESC2_INDEX_SELECTED = 'SET_HRMS15E_DETAIL2_DESC2_INDEX_SELECTED'

export const GET_HRMS15E_FLG_PROCESS = 'GET_HRMS15E_FLG_PROCESS'
export const SET_HRMS15E_FLG_PROCESS = 'SET_HRMS15E_FLG_PROCESS'



// WEBPACK FOOTER //
// ./src/store/modules/hrms15e/mutation-types.js